let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e53Dv")).then(() => parcelRequire('bFn0v'));